<div class="flex flex-col space-y-1">
  <label *ngIf="label" class="text-sm font-medium text-gray-700">
    {{ label }}
    <span *ngIf="isRequired" class="text-red-500 cursor-help relative group">
      *
      <span
        class="absolute left-0 bottom-full mb-1 w-max px-2 py-1 text-xs text-white bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-all duration-200 transform translate-y-1 group-hover:translate-y-0"
      >
        Este campo es obligatorio
      </span>
    </span>
  </label>
  <textarea
    [formControl]="formControl"
    [placeholder]="placeholder"
    [rows]="rows"
    class="w-full min-h-48 px-3 py-2 border border-gray-300 rounded-md placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary text-gray-800"
  >
  </textarea>
  <app-show-error
    *ngIf="showError"
    [control]="control"
    [fieldName]="normalizedFieldName"
  >
  </app-show-error>
</div>
